module.exports = __webpack_public_path__ + "img/baby_photo.bda0dfcb.png";